/** @format */

import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { HmfPriceComponent, HmfProductImageComponent } from '@dsg-tech/homefield-angular';

import { BottomPaginationComponent } from '../bottom-pagination/bottom-pagination.component';
import type { HmfProductImageData } from '@dsg-tech/homefield-utils';
import type { ProductDetail } from '@plp/data-access/interfaces';
import { Store } from '@ngrx/store';
import { TopPaginationComponent } from '../top-pagination/top-pagination.component';
import { selectProductList } from '@plp/data-access/state';

@Component({
  selector: 'plp-components-color-breakout',
  imports: [
    HmfPriceComponent,
    HmfProductImageComponent,
    TopPaginationComponent,
    BottomPaginationComponent,
  ],
  templateUrl: './color-breakout.component.html',
  styleUrl: './color-breakout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorBreakoutComponent {
  private readonly store = inject(Store);

  readonly productListData = this.store.selectSignal(selectProductList);
  readonly productVOs = computed(() => this.productListData()?.productVOs ?? []);
  readonly productDetails = computed(() => this.productListData()?.productDetails ?? {});

  readonly imageData = computed<Record<string, HmfProductImageData>>(() => {
    const productList = this.productListData();
    const productVOs = productList?.productVOs;
    if (!productVOs) {
      return {};
    }
    return productVOs.reduce(
      (acc, plpProduct) => {
        const productDetail =
          productList?.productDetails?.[plpProduct.parentCatentryId || plpProduct.catentryId];
        acc[plpProduct.parentCatentryId || plpProduct.catentryId] =
          this.getImageData(productDetail);
        return acc;
      },
      {} as Record<string, HmfProductImageData>,
    );
  });

  private getImageData(productDetail: ProductDetail | undefined): HmfProductImageData {
    return {
      imageUrl: '',
      defaultColor: productDetail?.skuAttributes?.Color?.[0] ?? '',
    };
  }
}
